export const PREVIEW_TYPES = {
  IMAGE: "image",
  VIDEO: "video"
};